var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssignedLocations = function SvgAssignedLocations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H0V8l7-3v2l5-2v3h3l1-8h3l1 8zM10 7.95l-5 2V8L2 9.32V18h16v-8h-8zM9 16h2v-4H9zm-4 0h2v-4H5zm10-4h-2v4h2z"
  })));
};
export { SvgAssignedLocations as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDIwSDBWOEw3IDVWN0wxMiA1VjhIMTVMMTYgMEgxOUwyMCA4VjIwWk0xMCA3Ljk1TDUgOS45NVY4TDIgOS4zMlYxOEgxOFYxMEgxMFY3Ljk1Wk05IDE2SDExVjEySDlWMTZaTTUgMTZIN1YxMkg1VjE2Wk0xNSAxMkgxM1YxNkgxNVYxMloiIC8+Cjwvc3ZnPgo=";